import { render, staticRenderFns } from "./ui-popup-component.vue?vue&type=template&id=8cc48eaa&scoped=true&"
import script from "./ui-popup-component.vue?vue&type=script&lang=ts&"
export * from "./ui-popup-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-popup-component.vue?vue&type=style&index=0&id=8cc48eaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc48eaa",
  null
  
)

export default component.exports